import { CommonModule } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';
import { Params, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition, faAngleRight } from '@fortawesome/pro-solid-svg-icons';

export type Breadcrumb = {
    title: string;
    route: string[];
    params?: Params;
};

export enum BreadcrumbTheme {
    DEFAULT,
    LARGE
}

@Component({
    selector: 'fdx-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrl: './breadcrumbs.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        FontAwesomeModule,
        RouterModule
    ]
})
export class BreadcrumbsComponent {

    readonly breadcrumbs: InputSignal<Breadcrumb[]> = input<Breadcrumb[]>([]);
    readonly currentPageTitle: InputSignal<string> = input<string>('');
    readonly theme: InputSignal<BreadcrumbTheme> = input<BreadcrumbTheme>(BreadcrumbTheme.DEFAULT);

    readonly dividerIcon: IconDefinition = faAngleRight;

    getClasses(): string[] {

        if( this.theme() === BreadcrumbTheme.LARGE ) {
            return ['breadcrumb-xl'];
        }

    }

    getClassesTitle(): string[] {

        if( this.theme() === BreadcrumbTheme.DEFAULT ) {
            return ['fw-medium'];
        }

        if( this.theme() === BreadcrumbTheme.LARGE ) {
            return ['fw-semibold'];
        }


    }

}
